module.exports = __webpack_public_path__ + "img/new_index_service_icon2.644d3e48.png";